import React from "react";
import { useLocation } from "react-router-dom";
import AudioEditor from "../../components/common/AudioEditor/AudioEditor";
import styles from "./AudioEditing.module.css";

const AudioEditing: React.FC = () => {
    // Set when arriving from the "Audio editing" action of Projects or Drafts. Same
    // router-state mechanism as the existing "send to text-to-speech" action.
    const location = useLocation();
    const state = location.state as { audioAIId?: unknown } | null;
    const audioAIId = typeof state?.audioAIId === "string" ? state.audioAIId : null;

    return (
        <div className={styles.page}>
            <AudioEditor withPageHeader bootstrapAudioAIId={audioAIId} />
        </div>
    );
};

export default AudioEditing;
